// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","viewsChart":"MBAfn3zVy8F8LtiEzYxfI"};